import classNames from 'clsx';
import React, { type ReactElement, memo } from 'react';
import { type ListChildComponentProps, areEqual } from 'react-window';
import { AdvBanner } from 'reactApp/ui/Mobile/Datalist/AdvBanner/AdvBanner';

import styles from './VirtualList.css';

export const VirtualListRow = memo(function VirtualListRow(props: ListChildComponentProps): ReactElement | null {
    const { index, style, data } = props;
    const { list, itemActiveIndex, renderItem, dividerSize } = data;
    const key = typeof list[index] === 'string' ? list[index] : list[index].id;
    const handleRef = index === itemActiveIndex ? data.handleRef : null;

    if (list[index].divider) {
        return (
            <div
                style={style}
                key={key + index}
                className={classNames(styles.dividerContainer, styles.dividerList, {
                    [styles.dividerAdv]: list[index].showAdv,
                })}
                data-qa-divider={list[index].text}
            >
                <div
                    className={classNames(styles.divider, {
                        [styles[`divider_${dividerSize}`]]: !!dividerSize,
                    })}
                >
                    {list[index].text}
                    {list[index].showAdv && <AdvBanner />}
                </div>
            </div>
        );
    }

    return (
        <div style={style} key={key + index} ref={handleRef}>
            {renderItem(data.list[index], { index })}
        </div>
    );
}, areEqual);
